import { render } from "./onboarding-filters.vue?vue&type=template&id=b65da51e&lang=pug"
import script from "./onboarding-filters.vue?vue&type=script&lang=js"
export * from "./onboarding-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__